<template>
  <div>
    <BasicDialog @close="closeDialog">
      <v-row>



        <v-col cols="12" class="d-flex flex-row justify-center align-center">
          <logo-background></logo-background>
          <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
            <img :src="AppConfigs.staticImages.SHAREONWHATSAPP" alt="Share on WhatsApp" style="width: 70%; height: auto;">
            <img :src="AppConfigs.staticImages.PRIMARYCHECK" v-if="!isAvailable" style="position: absolute; top: -25%; left: -10%;">
          </div>
        </v-col>



        <v-col cols="12" class="d-flex flex-row justify-center text-center text-h5 font-weight-bold">
          Share on WhatsApp
        </v-col>



        <v-col cols="12" class="text-center">
          Share on WhatsApp and earn {{ coinsForSharingOnWhatsApp }} coins
        </v-col>



        <v-col cols="12" class="d-flex flex-row justify-center">
          <v-btn rounded="pill" :disabled="!isAvailable"
            class="  button--primary text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex"
            @click="shareOnWhatsApp">
            Share Now
          </v-btn>
        </v-col>



      </v-row>
    </BasicDialog>
  </div>
</template>




<script>

import { AppConfigs } from "@/app.configs";
import { computed, inject, provide } from 'vue';
import { UserActivityStore } from '@/store/UserActivityStore';

import LogoBackground from "@/icons/LogoBackground.vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";

export default {
  name: 'ShareOnWhatsAppDialog',
  components: {
    BasicDialog,
    LogoBackground,
  },
  props: {
    shareMessage: {
      type: String,
      default: 'Check out this awesome website!', // Default share message
    },
    shareUrl: {
      type: String,
      default: 'https://webappdev.bountyhunterapp.co', // Default URL to share
    }
  },
  setup(props, { emit }) {

    const inHouseTaskStore = UserActivityStore();
    
    let openDialog = inject('inHouseTaskOpenDialog');
    provide('openDialog', openDialog);



    const coinsForSharingOnWhatsApp = computed(() => inHouseTaskStore.selectedInHouseTask.coins_amount);
    const isAvailable = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);

    const defaultShareMessage = 'Check out this awesome website!';
    const defaultShareUrl = 'https://webappdev.bountyhunterapp.co';


    function closeDialog() {
      emit('close');
    }

    function shareOnWhatsApp() {
      const message = encodeURIComponent(`${defaultShareMessage} ${defaultShareUrl}`);
      const whatsappUrl = `https://wa.me/?text=${message}`;
      window.open(whatsappUrl, '_blank');
      inHouseTaskStore.redeemCoinsForSelectedInHouseTask();
    }

    return {
      AppConfigs,
      closeDialog,
      isAvailable,
      shareOnWhatsApp,
      coinsForSharingOnWhatsApp,
    };
  },
};
</script>
